import {
  addMonths,
  getTime,
  setDate,
  setHours,
  setMilliseconds,
  setMinutes,
  setSeconds,
  toDate,
} from 'date-fns/fp';
import { formatInTimeZone } from 'date-fns-tz/fp';
import flow from 'lodash/fp/flow';

const JSTTimeZone = 'Asia/Tokyo';
export const toNextMonthDayStr = (day: string, now: number) => {
  return flow(
    toDate,
    addMonths(1),
    formatInTimeZone(`yyyy年M月${day}日`, JSTTimeZone),
  )(now);
};

const JST_OFFSET = -9 * 60;

const toJSTWithSameLocalTime = (ms: number) => {
  return ms + (JST_OFFSET - new Date().getTimezoneOffset()) * 60 * 1000;
};

const toLocalWithSameLocalTime = (ms: number) => {
  return ms + (new Date().getTimezoneOffset() - JST_OFFSET) * 60 * 1000;
};

export const addDay = (ms: number, day: number) =>
  ms + 24 * 60 * 60 * 1000 * day;

export const toCurrMonthDayMs = (day: string, now: number) => {
  return flow(
    toLocalWithSameLocalTime,
    toDate,
    setHours(0),
    setMinutes(0),
    setSeconds(0),
    setMilliseconds(0),
    setDate(+day),
    getTime,
    toJSTWithSameLocalTime,
  )(now);
};
export const toNextMonthDayMs = (day: string, now: number) => {
  return flow(
    toLocalWithSameLocalTime,
    toDate,
    addMonths(1),
    setHours(0),
    setMinutes(0),
    setSeconds(0),
    setMilliseconds(0),
    setDate(+day),
    getTime,
    toJSTWithSameLocalTime,
  )(now);
};

export type CustomerKind = 'personal' | 'corporate' | 'unknown';
